module.exports = __webpack_public_path__ + "img/believeLogoMini.511f5301.png";